import React from 'react'
import TransactionChart from '../Buy/TransactionChart'
import Progress from '../Home/Progress'
import Button from '../SelectValue/Button'
import Lock from '../../Assets/images/lock.png'
import { Link, NavLink, useParams } from 'react-router-dom'
import { format, parseISO, isValid } from 'date-fns'
function TargetDetails() {
  const { planid, cashout, name, enddate, startdate, per, target, status, amount } = useParams()
  const formattedEndDate = (() => {
    try {
      if (!enddate || enddate === 'undefined' || enddate === 'null') return ''
      const date = parseISO(enddate)
      if (isValid(date)) return format(date, 'MMM d, yyyy')
      if (enddate.includes(',')) {
        const parts = enddate.split(',')
        if (parts.length >= 3) {
          const dateObj = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10))
          if (isValid(dateObj)) return format(dateObj, 'MMM d, yyyy')
        }
      }
      return ''
    } catch {
      return ''
    }
  })()

  return (
    <div>

      <div className=' flex flex-wrap gap-2 mb-5'>
        <NavLink className={({ isActive }) => {
          return (' text-back-color2 py-2 border rounded-[4px] px-4 sm:px-6 flex-1 text-center ' + (
            !isActive ? ' bg-[#F7F8FB] ' : ' border-gray-200  bg-white '
          ))
        }} to={`/save/plan/${name}/details/${planid}/${cashout}/${name}/${enddate}/${startdate}/${per}/${target}/${status}/${amount}`}>
          <p>Details</p>
        </NavLink>
        <NavLink className={({ isActive }) => {
          return (' text-back-color2 py-2 border rounded-[4px] px-4 sm:px-6 flex-1 text-center ' + (
            !isActive ? ' bg-[#F7F8FB] ' : ' border-gray-200  bg-white '
          ))
        }} to={`/save/plan/${name}/transactions/${planid}/${status}/${amount}/${startdate}`}>
          <p>Transactions</p>
        </NavLink>
      </div>
      <p className=' text-primary-color6 mb-2'>Current balance</p>
      <p className=' text-back-color2 text-2xl sm:text-3xl mb-4 font-[500]'>NGN {cashout}</p>
      <p className=' text-primary-color6 mb-4'>{per === 'null' ? ' N/A' : per} % achieved of your NGN {target === "null" ? ' N/A' : target} target</p>
      <Progress
        value={per === 'null' ? 0 : Number(per)}
      />
      <div className=' mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4'>
        <Link to='/save/targetplanname/buytarget/card'>
          {/* <div className='   col-span-2'>
            <Button
                name='Add cash'
                
            />
        </div> */}
        </Link>


      </div>
      <div className=' mt-5 overflow-x-auto'>
        {/* <TransactionChart /> */}
      </div>
      <div className=' flex flex-col sm:flex-row rounded-lg gap-3 border border-primary-color6 p-3 mt-8'>
        <div className=' flex-shrink-0'>
          <img src={Lock} alt='Lock' />
        </div>
        <div>
          <p className=' text-back-color2 text-[16px] font-[500] mb-1'>Your plan is locked</p>
          <p className=' text-primary-color6 text-sm sm:text-base'>Your plan is locked from withdrawal until {formattedEndDate} your funds will be sent to your wallet on maturity.</p>
        </div>
      </div>
    </div>
  )
}

export default TargetDetails